import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: 32,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginBottom: 10
    }
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 600,
    color: GRAY_COLORS[900],
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    }
  },
  headerItems: {
    display: 'flex',
    gap: 12,
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  actionButtons: {
    marginBottom: 20,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap'
    }
  },
  addEventBtn: {
    display: 'flex',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  actionItemsBtn: {
    border: `1px solid ${GRAY_COLORS[300]}`,
    borderRadius: 8
  },
  actionItems: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap'
  },
  arrowLeft: {
    marginTop: 32,
    marginBottom: 32,
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      marginBottom: 20
    }
  },
  backButton: {
    padding: 0,
    margin: 0
  },
  managerIcon: {
    padding: 0
  },
  assignManager: {
    marginRight: 12
  },
  inputLabel: {
    marginBottom: 5
  },
  phoneList: {
    borderRadius: 4,
    padding: '8px 12px',
    fontWeight: 500
  },
  docList: {
    borderRadius: 4,
    padding: '8px 12px',
    fontWeight: 500,
    overflow: 'auto'
  }
}))
